import { Injectable } from '@angular/core';
import { Resetable } from '../../resetter/resetable';
import { Credentials } from 'src/app/_model/credentials';

@Injectable()
export abstract class CredentialsDaoService implements Resetable {
  public abstract saveCredentials(credentials: Credentials): Promise<void>;
  public abstract getCredentials(): Promise<Credentials>;
  public abstract reset(): Promise<void>;
  public abstract clear(): Promise<void>;
}
